import { useContext } from 'react';
import { useWizardService } from '@bingads-webui-react/wizard';

export const useMultiAdFormatAdsManagerRepository = () => {
  const { state } = useWizardService();

  const load = () => new Promise((resolve) => {
    resolve(state.context.wizardData);
  });

  const save = useContext(() => Promise.resolve());

  return {
    load,
    save,
  };
};
